import axios from 'axios'

// axios.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem('token')
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`
//     }
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )
// export default axios

const api = axios.create({
  // baseURL: import.meta.env.VITE_API_URL,
  headers: { 'Content-Type': 'application/json' }
})

let requestCount = 0

function updateCursor(show) {
  if (show) {
    requestCount++
    document.body.classList.add('wait-cursor')
  } else {
    requestCount = Math.max(0, requestCount - 1)
    if (requestCount === 0) {
      document.body.classList.remove('wait-cursor')
    }
  }
}

api.interceptors.request.use(
  config => {
    updateCursor(true)
    // 💡 Proactive Safety Net: Detect and fix double-prefixing (e.g., /eapharmics/eapharmics/ -> /eapharmics/)
    // This prevents "Invalid header token" proxy errors if config becomes redundant.
    const prefix = '/eapharmics'
    const doublePrefix = `${prefix}${prefix}`
    if (config.url && config.url.startsWith(doublePrefix)) {
      console.warn(`🛠️ Normalizing double-prefix in URL: ${config.url}`)
      config.url = config.url.replace(doublePrefix, prefix)
    }

    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      console.log(`📤 API Request: ${config.method?.toUpperCase()} ${config.url}`, {
        authHeader: config.headers['Authorization']?.substring(0, 20) + '...'
      })
    } else {
      console.warn('🔑 No token found in sessionStorage for request:', config.url)
    }
    return config
  },
  error => {
    updateCursor(false)
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => {
    updateCursor(false)
    return response
  },
  error => {
    updateCursor(false)
    if (error.response?.status === 401) {
      console.error('🚫 401 Unauthorized:', error.config?.url)
    }
    return Promise.reject(error)
  }
)

export default api
